import React, { Component } from "react";
import { Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import { putRequest } from "../../../../utils/httpRequest";
import AlertIcon from "../../../Notifications/AlertIcon";

interface Props {
  notification: any;
  history?: any;
}

interface State {
  showNotification: boolean;
}

class Notification extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      showNotification: true,
    };
  }

  componentDidMount() {
    $(document).on("click", "span[data-url]", function (e) {
      window.open($(this).data("url"), "_blank");
    });

    // setTimeout(this.closeNotification, 10000);
  }

  // Acting on a notification is not the same as dismissing it. The toast as a
  // whole is the dismiss target, so without this the click bubbles to that
  // handler, which cancels the event and the learner goes nowhere -- the link
  // reads as broken. Stop it there and let the Link navigate; the notification
  // has been dealt with either way, so it is marked seen on the way out.
  visitNotificationHref = (e) => {
    e.stopPropagation();

    this.markAsSeen();
  };

  markAsSeen = () => {
    const { notification } = this.props;

    return putRequest(
      `/api/notifications/${notification.id}/mark_as_seen.json`,
      {},
    ).catch((error) =>
      (window as any).honeybadger?.notify(
        `Error updating recent notification for ${notification.id}, data: ${error.response.data}`,
      ),
    );
  };

  closeNotification = () => {
    const { notification } = this.props;

    ($(`.toast-${notification.id}`) as any).transition("fly left");
    return this.markAsSeen().then(() =>
      this.setState({ showNotification: false }),
    );
  };

  onCloseNotification = (e) => {
    e.preventDefault();

    this.closeNotification();
  };

  render() {
    const { notification } = this.props;
    const { showNotification } = this.state;
    return (
      <>
        {showNotification && (
          // Not an <a>: the one link in here is the target ("View answer",
          // "Get certificate"), and an anchor cannot legally contain another
          // one. The toast itself is still the dismiss target, so the cross
          // stays a marker rather than a second control.
          <div
            className={`toast toast-${notification.id}${
              notification.href ? "" : " no-href"
            }`}
            onClick={this.onCloseNotification}
          >
            <AlertIcon notification={notification} baseClass="notif-ic" />
            <div className="notif-body">
              <span className="notif-text">
                <strong>
                  {/* @ts-ignore */}
                  {ReactHtmlParser(notification.title)}
                </strong>{" "}
                {/* @ts-ignore */}
                {ReactHtmlParser(notification.body)}
              </span>
              {notification.target_name &&
                (notification.href ? (
                  <Link
                    className="notif-target"
                    to={notification.href}
                    onClick={this.visitNotificationHref}
                  >
                    {/* @ts-ignore */}
                    {ReactHtmlParser(notification.target_name)}
                  </Link>
                ) : (
                  <span className="notif-target">
                    {/* @ts-ignore */}
                    {ReactHtmlParser(notification.target_name)}
                  </span>
                ))}
            </div>
            <span className="toast-close" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <path
                  d="M6 6l12 12M18 6L6 18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </span>
          </div>
        )}
      </>
    );
  }
}

export default Notification;
